// 記事作成/編集関連処理
import commonClass from "./commonClass";

export default class articleClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    // テンプレート
    this._$tmplLnk;
    this._$tmpTabParts;
    this._$tmpTabForm;
    this._$tmpTabHtml;
    this._$tmpTabFormTtl;
    this._$tmpTabFormCont;
    this._$tmpTabFormImage;

    // ブロック削除関連
    this._prtItem = '.js-art_prtItem';
    this._delItem = '.js-art_delItem';

    // タブ関連
    this._tabPrt = '.js-art_tabPrt';
    this._tabTrg = '.js-art_tabTrg';
    this._tabTrgCtnr = '.js-art_tabTrgCtnr';
    this._tabAdd = '.js-art_tabAdd';
    this._tabAddTrg = '.js-art_tabAddTrg';
    this._tabTgt = '.js-art_tabTgt';
    this._tabTgtCtnr = '.js-art_tabTgtCtnr';
    this._tabDel = '.js-art_tabDel';
    this._tabLock = '.js-art_tabLock';
    this._tabSurvey = '.js-art_tabSurvey';
    this._tabInputArea = '.js-art_tabInputArea';
    this._tabChangeFmtTrg = '.js-art_tabChangeFmtTrg';
    this._tabChangeFmt_html = '.js-art_tabChangeFmt_html';
    this._tabChangeFmt_form = '.js-art_tabChangeFmt_form';
    this._tabFormAddArea = '.js-art_tabFormAddArea';
    this._tabFormAddTrg_ttl = '.js-art_tabFormAddTrg-ttl';
    this._tabFormAddTrg_cont = '.js-art_tabFormAddTrg-cont';
    this._tabFormAddTrg_image = '.js-art_tabFormAddTrg-image';

    // 関連情報/関連リンクエリア
    this._addLnk = '.js-art_addLnk';
    this._$addLnkArea = $('.js-art_addLnkArea');

    // 指定方法選択(switchShowClass.jsで代替したのでコメントアウト)
    // this._tglDesignation_trg = '.js-art_tglDesignation_trg';
    // this._tglDesignation_tgt = '.js-art_tglDesignation_tgt';

    // タイトル連番
    this._ttlSeqNumPrt = '.js-art_ttlSeqNum_prt';
    this._ttlSeqNumTtl = '.js-art_ttlSeqNum_ttl';
    this._ttlSeqDataName = 'data-ttlSeqType';

    // CSS編集項目
    this._cssEdit = '.js-art_cssEdit';
  }

  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._getTemplate();
    // switchShowClass.jsで代替したのでコメントアウト
    // cls._toggleDesignation();
    cls._initTab();
    cls._initLink();

    // 項目ソート（ブロック）
    $('.js-sortable_prt').each(function(index, el) {
      cls._blockSortable($(el));
    });

    // チェックボックスON/OFFでブロック全体をDisable（削除）にする
    APP.BlockDisable._setSelector(cls._delItem, cls._prtItem);
  }

  // テンプレート取得
  _getTemplate() {
    var cls = this;

    // clone前に一旦datepickerをdestroy
    var $tmplLnk = $('.js-art_lnkTmpl');
    $tmplLnk.find('.js-datepicker').datepicker('destroy');
    cls._$tmplLnk = $tmplLnk.clone().removeClass('js-art_lnkTmpl');
    $tmplLnk.remove();

    var $tmpTabParts = $('.js-art_tabPartsTmpl');
    cls._$tmpTabParts = $tmpTabParts.clone().removeClass('js-art_tabPartsTmpl');
    $tmpTabParts.remove();

    var $tmpTabForm = $('.js-art_tabFormTmpl');
    cls._$tmpTabForm = $tmpTabForm.clone().removeClass('js-art_tabFormTmpl').show();
    $tmpTabForm.remove();

    var $tmpTabHtml = $('.js-art_tabHtmlTmpl');
    cls._$tmpTabHtml = $tmpTabHtml.clone().removeClass('js-art_tabHtmlTmpl').show();
    $tmpTabHtml.remove();

    var $tmpTabFormTtl = $('.js-art_tabFormTtlTmpl');
    cls._$tmpTabFormTtl = $tmpTabFormTtl.clone().removeClass('js-art_tabFormTtlTmpl');
    $tmpTabFormTtl.remove();

    var $tmpTabFormCont = $('.js-art_tabFormContTmpl');
    cls._$tmpTabFormCont = $tmpTabFormCont.clone().removeClass('js-art_tabFormContTmpl');
    $tmpTabFormCont.remove();

    var $tmpTabFormImage = $('.js-art_tabFormImageTmpl');
    cls._$tmpTabFormImage = $tmpTabFormImage.clone().removeClass('js-art_tabFormImageTmpl');
    $tmpTabFormImage.remove();
  }

  _initTab() {
    var cls = this;

    // タブ切り替え
    $(document).on('click', cls._tabTrg, function() {
      var $this = $(this);

      if ($this.hasClass('is-current')) {
        return false;
      }

      var tabParts = cls._getTabParts($this);
      var idx = tabParts.$trg.index($this);

      tabParts.$trg.removeClass('is-current');
      tabParts.$tgt.removeClass('is-show');

      tabParts.$trg.eq(idx).addClass('is-current');
      tabParts.$tgt.eq(idx).addClass('is-show');

      return false;
    });

    // タブ追加
    $(document).on('click', cls._tabAddTrg, function() {
      var $this = $(this);
      var tabParts = cls._getTabParts($this);

      var $addTab = cls._$tmpTabParts.find(cls._tabTrg).clone();
      $addTab.find('button span').text(tabParts.$trg.length + 1);

      var $addCont = cls._$tmpTabParts.find(cls._tabTgt).clone();
      var $addInputArea;

      // html | input判定
      if ($(cls._tabPrt).hasClass('is-formInput')) {
        $addInputArea = cls._$tmpTabForm.clone();
        cls._blockSortable($addInputArea.find('.js-sortable_prt'));
      } else {
        $addInputArea = cls._$tmpTabHtml.clone();
      }
      $addCont.find(cls._tabInputArea).append($addInputArea);

      // 閲覧制限タブが存在している場合は追加タブを制限状態にする 2019/12/1 Tamura 追加
      var isLocked = tabParts.$tgt.find(cls._tabLock).filter(':checked').length > 0;
      if (isLocked) {
        $addCont.find(cls._tabLock).prop('checked', true);
      }

      // 閲覧制限タブが存在している場合は追加タブを制限状態にする 2019/11/20 Tamura コメントアウト
      // var isLocked = tabParts.$tgt.find(cls._tabLock).filter(':checked').length > 0;
      // if (isLocked) {
      //   $addTab.addClass('is-lock');
      // }

      tabParts.$trg.removeClass('is-current');
      tabParts.$tgt.removeClass('is-show');

      $this.parent(cls._tabAdd).before($addTab);
      tabParts.$tgtCtnr.append($addCont);

      return false;
    });

    // タブ削除
    $(document).on('change', cls._tabDel, function() {
      var $this = $(this);
      var tabParts = cls._getTabParts($this);

      // カレント状態のタブとタブコンテンツを取得
      var $currentTrg = tabParts.$trg.filter(function(index, el){
        return $(el).hasClass('is-current');
      });

      if ($this.prop('checked')) {
        $currentTrg.addClass('is-del');
      } else {
        $currentTrg.removeClass('is-del');
      }

      return false;
    });

    // タブ閲覧制限
    $(document).on('change', cls._tabLock, function() {
      var $this = $(this);
      var tabParts = cls._getTabParts($this);

      // カレント状態のタブとタブコンテンツを取得
      var $currentTrg = tabParts.$trg.filter(function(index, el){
        return $(el).hasClass('is-current');
      });
      var currentIdx = tabParts.$trg.index($currentTrg);

      // カレントタブ以外の閲覧制限チェックボックスを無効にする 2019/12/1 Tamura if文追加
      if ($this.prop('checked') == false) {
        tabParts.$tgt.find(cls._tabLock).filter(function (index, el) {
          return index !== currentIdx;
        }).prop('checked', false);
      }

      // 閲覧制限チェックよりも後の項目にはチェックを入れる　2019/12/1 Tamura 追加
      if ($this.prop('checked')) {
        tabParts.$tgt.find(cls._tabLock).filter(function (index, el) {
            return index > currentIdx;
        }).prop('checked', true);
      }

        if ($this.prop('checked')) {
            // タブボタンのクラス変更　2019/11/20 Tamura 条件を > から　== へ　変更
            tabParts.$trg.each(function (index, el) {
                if (index == currentIdx) {
                    $(el).addClass('is-lock');
                    $(el).addClass('is-lock-sub');
                } else {
                    if (index > currentIdx) {
                        $(el).addClass('is-lock-sub');
                    } else {
                        $(el).removeClass('is-lock');
                        $(el).removeClass('is-lock-sub');
                    }
                }
            });
        } else {
            // タブボタンのクラス変更
            tabParts.$trg.removeClass('is-lock');

            tabParts.$trg.each(function (index, el) {
                $(el).removeClass('is-lock-sub');
            });
        }

      return false;
    });

    $(document).on('change', cls._tabSurvey, function() {
      var $this = $(this);

      var tabParts = cls._getTabParts($this);

      // カレント状態のタブとタブコンテンツを取得
      var $currentTrg = tabParts.$trg.filter(function(index, el){
        return $(el).hasClass('is-current');
      });
      var currentIdx = tabParts.$trg.index($currentTrg);

      // カレントタブ以外の閲覧制限チェックボックスを無効にする
      tabParts.$tgt.find(cls._tabSurvey).filter(function(index, el) {
        return index !== currentIdx;
      }).prop('checked', false);

      if ($this.prop('checked')) {
        // タブボタンのクラス変更
        tabParts.$trg.each(function(index, el) {
          if (index  === currentIdx) {
            $(el).addClass('is-survey');
          } else {
            $(el).removeClass('is-survey');
          }
        });
      } else {
        // タブボタンのクラス変更
        $currentTrg.removeClass('is-survey');
      }
    });

    // タブドラッグ＆ドロップ
    // $(cls._tabTrgCtnr).each(function(index, el) {
    //   cls._tabSortable($(el));
    // });

    // ラジオボタンのクリックで即changeを無効にする
    $(document).on('click', cls._tabChangeFmt_html, function() {
      return false;
    });
    $(document).on('click', cls._tabChangeFmtTrg, function() {
      $(cls._tabChangeFmt_html).prop('checked', true).removeClass('js-modal');

      $(cls._tabChangeFmt_form).prop('disabled', true);

      var tabParts = $(cls._tabPrt);
      tabParts.removeClass('is-formInput').addClass('is-htmlInput');
      tabParts.each(function(index, el) {
        $(el).find(cls._tabInputArea).empty().append(cls._$tmpTabHtml.clone());
      });

      // CSS編集項目の表示
      $(cls._cssEdit).show();

      // モーダル閉じる
      APP.modal._close($(this));

      return false;
    });

    // フォームパーツ追加：見出し
    $(document).on('click', cls._tabFormAddTrg_ttl, function() {
      var $tmp = cls._$tmpTabFormTtl.clone();
      $tmp.appendTo($(this).closest(cls._tabInputArea).find(cls._tabFormAddArea)).fadeIn();
      cls._setSequenceNumToTtl($tmp);

      return false;
    });

    // フォームパーツ追加：本文
    $(document).on('click', cls._tabFormAddTrg_cont, function() {
      var $tmp = cls._$tmpTabFormCont.clone();
      $tmp.appendTo($(this).closest(cls._tabInputArea).find(cls._tabFormAddArea)).fadeIn();
      cls._setSequenceNumToTtl($tmp);

      return false;
    });

    // フォームパーツ追加：画像
    $(document).on('click', cls._tabFormAddTrg_image, function() {
      var $tmp = cls._$tmpTabFormImage.clone();
      $tmp.appendTo($(this).closest(cls._tabInputArea).find(cls._tabFormAddArea)).fadeIn();
      cls._setSequenceNumToTtl($tmp);

      return false;
    });
  }

  // イベント発火した要素に関連するタブパーツを取得して返却
  _getTabParts($child) {
    var cls = this;

    var retObj = {};
    var $prt = $child.closest(cls._tabPrt);

    retObj.$prt = $prt;
    retObj.$trg = $prt.find(cls._tabTrg);
    retObj.$trgCtnr = $prt.find(cls._tabTrgCtnr);
    retObj.$tgt = $prt.find(cls._tabTgt);
    retObj.$tgtCtnr = $prt.find(cls._tabTgtCtnr);

    return retObj;
  }

  // タブドラッグドロップ
  _tabSortable($tgt) {
    var cls = this;

    var $self = $tgt;
    var idxBefore;
    var idxAfter;
    var tabParts;

    $self.sortable({
      cancel: cls._tabAddTrg,
      start: function(e, ui) {
        tabParts = cls._getTabParts(ui.item);
        idxBefore = tabParts.$trg.index(ui.item);
      },
      stop: function(e, ui) {
        if (ui.item.is(':last-child')) {
          // 最後尾は常に「＋」ボタンになるので最後尾配置された場合は移動キャンセル
          $self.sortable('cancel');
        } else {
          // 変更後のインデックス番号を取得
          tabParts = cls._getTabParts(ui.item);
          idxAfter = tabParts.$trg.index(ui.item);
        }

        // 移動していた場合、対応するコンテンツも合わせて移動する
        if (idxBefore !== idxAfter) {
          var $moveTgt = tabParts.$tgt.eq(idxBefore).clone();
          tabParts.$tgt.eq(idxBefore).remove();

          // removeしたので要素集を一度アップデート
          tabParts = cls._getTabParts(ui.item);

          // 対応コンテンツの移動
          if (idxAfter - 1 < 0) {
            // 先頭への移動
            tabParts.$tgt.eq(0).before($moveTgt);
          } else {
            // 先頭以外への移動
            tabParts.$tgt.eq(idxAfter - 1).after($moveTgt);
          }

          // タブの連番テキスト振り直し
          tabParts.$trg.each(function(index, el) {
            $(el).find('button span').text(index + 1);
          });
        }
      }
    });
  }

  // 「指定方法」ラジオ選択に応じて「クライアント」セレクトの切り替え
  // _toggleDesignation() {
  //   var cls = this;

  //   var $trg = $(cls._tglDesignation_trg);
  //   var $trg_checked = $trg.filter(':checked');
  //   var $tgt = $(cls._tglDesignation_tgt);
  //   var $tgt_variable = $tgt.filter('.is-variable');
  //   var $tgt_single = $tgt.filter('.is-single');

  //   // 「指定方法」ラジオの初期状態に併せて表示するセレクトを変更
  //   if ($trg_checked.hasClass('is-variable') || !$trg_checked.length > 0) {
  //     $tgt_single.toggle();
  //   }
  //   if ($trg_checked.hasClass('is-single')) {
  //     $tgt_variable.toggle();
  //   }

  //   // 「指定方法」ラジオが変更されたらセレクトの表示切替
  //   $(document).on('change', cls._tglDesignation_trg, function() {
  //     var $this = $(this);

  //     $tgt.toggle();
  //     return false;
  //   });
  // }

  // 連番セクションののソート
  _blockSortable($tgt, func) {
    var cls = this;

    $tgt.sortable({
      update: function(e, ui) {
        var $moveItm = ui.item;
        // タイトルの連番書き換え判定
        var doAddSequenceNum = $moveItm.find(cls._ttlSeqNumTtl).length > 0;
        if (doAddSequenceNum) {
          cls._setSequenceNumToTtl(ui.item);
        }
      }
    });
  }

  // タイトル部分の連番付与・更新処理
  _setSequenceNumToTtl($itm) {
    var cls = this;

    var $prt = $itm.closest(cls._ttlSeqNumPrt);
    var $ttl = $prt.find(cls._ttlSeqNumTtl);
    var ttlTypeArr = [];

    if ($ttl.attr(cls._ttlSeqDataName)) {
      // ソータブルエリアに複数タイプのタイトルがある場合、タイトルタイプ毎に連番を降る
      // タイトルタイプ別にjquery要素をまとめた配列を作成
      var dataArr = [];

      $ttl.each(function(index, el) {
        var $self = $(el);
        var ttlSeqType = $self.attr(cls._ttlSeqDataName);

        if (dataArr.indexOf(ttlSeqType) < 0) {
          dataArr.push(ttlSeqType);
        }
      });

      for (var i = 0; i < dataArr.length; i++) {
        ttlTypeArr.push($ttl.filter(function(index) {
          return $(this).attr(cls._ttlSeqDataName) === dataArr[i];
        }));
      }
    } else {
      // タイトルタイプ存在しない（1種類）の場合
      ttlTypeArr.push($ttl);
    }

    // タイトルタイプ毎にループで連番をふる
    for (var i = 0; i < ttlTypeArr.length; i++) {
      ttlTypeArr[i].each(function(index, el) {
        var $self = $(el);
        // タイトルテキストから末尾の数字を削除
        var txt = $self.text().replace(/[0-9]*$/, '');
        $self.text(txt + (index + 1));
        $self.val((index + 1));
      });
    }
  }

  // 「関連リンク」処理
  _initLink() {
    var cls = this;

    $(document).on('click', cls._addLnk, function() {
      var $tmp = cls._$tmplLnk.clone();

      // 画面に追加
      $tmp.find('.js-datepicker').attr('id', 'dp' + cls._getUniqueString());
      $tmp.find('.js-datepicker').datepicker(APP.DatePicker._baseSetting).next('.ui-datepicker-trigger').addClass('c-btn_datepick');
      $tmp.appendTo(cls._$addLnkArea).fadeIn();
      // タイトル連番
      cls._setSequenceNumToTtl($tmp);

      return false;
    });
  }

}